import { Dialog } from '@mui/material';
import React from 'react';
import { subHeadingStyle } from 'views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import styles from './styles.module.scss';

const ListingDialog = ({
    rows,
    open,
    setOpen,
    listingKey,
    title = "Listing",
    clickSearchHandler = () => { },
    warningData,
    serviceEntryType,
    vendorKey,
    receivingVendorKey,
    showItemOnly = false,
    onItemClick = () => { },
    includeEntrysheet = false,
    entrysheetKey,
    processType,
    activePlant,
    globalFilter

}) => {

    const searchHandler = ({ value, year }) => {
        let payload = {};

        if (serviceEntryType === "createSE") {
            payload = {
                poNumber: value,
                processType: processType
            };
        } else if (serviceEntryType === "listSE") {
            payload = {
                entrySheetNumber: value
            };
        } else if (serviceEntryType === "pendingSE" || serviceEntryType === "ariba") {
            payload = {
                uuid: value
            };
        }
        payload.plant = globalFilter?.plant?.length > 0 ? ([globalFilter?.plant[0]?.value]) : (activePlant?.map(p => p.value) || []);
        clickSearchHandler(payload);
    };


    const closeDialog = () => {
        setOpen(false);
    }

    return (
        <>
            <Dialog
                open={open}
                PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
            >
                <div className='p-4 confirm-rejection-dialog'>
                    <div className="d-flex justify-content-end">
                        <CrossIcon onClick={closeDialog} />
                    </div>

                    <div style={{ width: '500px' }}>
                        <div className="header d-flex justify-content-center">{title}</div>
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    {
                                        warningData ? <td className='mt-1 d-flex justify-content-center cursor link'>{warningData}</td> : rows?.map((item, index) => (
                                            <td style={subHeadingStyle} className='mt-1 d-flex justify-content-center cursor link' onClick={() =>
                                                showItemOnly
                                                    ? onItemClick(item)
                                                    : searchHandler({
                                                        value: item?.[listingKey],
                                                        // year: item?.[yearKey] || undefined,
                                                    })
                                            }
                                                key={`${item?.[listingKey]}-${index}`}>
                                                {includeEntrysheet ? `${item?.[listingKey]} - ${item?.[entrysheetKey]}` : item?.[listingKey]}
                                                &nbsp;
                                                {/* {yearKey && item?.[yearKey] ? `(${item?.[yearKey]})` : ""} */}
                                                {(receivingVendorKey && item?.[receivingVendorKey]) || (vendorKey && item?.[vendorKey]) ? (
                                                    ` [${[
                                                        item?.[receivingVendorKey],
                                                        item?.[vendorKey]
                                                    ].filter(Boolean).join(', ')}]`
                                                ) : ""}
                                            </td>
                                        ))
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Dialog>
        </>)
}

export default ListingDialog;